<template>
	<div class="info-collect">
		<van-form @submit="onSubmit">
			<van-field
				class="field-item"
				v-model="form.name"
				name="姓名"
				label="姓名"
				placeholder="姓名"
				:rules="[{ required: true, message: '请输入姓名' }]"
			/>
			<van-field
				name="radio"
				label="性别"
				class="field-item"
				:rules="[{ required: true, message: '请输入性别' }]"
			>
				<template #input>
					<van-radio-group
						v-model="form.gender"
						direction="horizontal"
					>
						<van-radio name="男">男</van-radio>
						<van-radio name="女">女</van-radio>
					</van-radio-group>
				</template>
			</van-field>
			<van-field
				type="number"
				class="field-item"
				v-model="form.mobile"
				name="手机号"
				label="手机号"
				placeholder="手机号"
				:rules="[
					{
						required: true,
						message: '请填写手机号',
					},
					{
						validator: validatorPhone,
						message: '请填写正确手机号',
					},
				]"
			/>
			<van-field
				rows="3"
				type="textarea"
				class="field-item"
				v-model="form.address"
				name="邮寄地址"
				label="邮寄地址"
				placeholder="邮寄地址"
				:rules="[
					{
						required: true,
						message: '请填写邮寄地址',
					},
				]"
			/>
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit"
					>提交</van-button
				>
			</div>
		</van-form>
	</div>
</template>

<script>
import Vue from 'vue';
import { Form, Field, Button, Radio, RadioGroup, Toast } from 'vant';
import $api from '@api';

Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Toast);

export default {
	data() {
		return {
			form: { gender: '男' },
		};
	},

	created() {
		const { openId } = this.$route.query;
		// let openId = 'otVZyt4pYHn1R0u_5iLvN4PZpW4';

		if (!openId) {
			this.$router.push('/r_result?openId=""');
			return;
		}
		this.openId = openId;
		this.getUserInfo(openId);
	},

	methods: {
		async onSubmit() {
			const params = { ...this.form, openId: this.openId };
			const res = await $api.collect_api.toSubmit(params);

			if (res.meta.errCode !== 0) {
				Toast('提交信息失败!');
				return;
			}
			this.$router.push(`/r_result?openId=${this.openId}`);
		},
		async getUserInfo(openId) {
			const res = await $api.collect_api.getUserInfo({ openId });

			if (res.meta.errCode !== 0) {
				this.$router.push('/r_result?openId=""');
				return;
			}
			const info = res.data || {};

			if (!info.gender) {
				info.gender = '男';
			}

			this.$set(this, 'form', info);
		},
		validatorPhone(val) {
			return /^1[0123456789]\d{9}$/.test(val);
		},
		validatorEmail(val) {
			return /^[A-Za-zd]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/.test(
				val
			);
		},
	},
};
</script>

<style lang="scss">
.info-collect {
	padding: 30px 10px;
	.field-item {
		margin-bottom: 20px;
	}
}
</style>
